module.exports = __webpack_public_path__ + "static/media/footer_photo.ace5935d.png";